import { render, staticRenderFns } from "./TrainingContract.vue?vue&type=template&id=fe1cced2&scoped=true&"
import script from "./TrainingContract.vue?vue&type=script&lang=ts&"
export * from "./TrainingContract.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingContract.vue?vue&type=style&index=0&id=fe1cced2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1cced2",
  null
  
)

export default component.exports